import { Component, Input, OnInit } from "@angular/core";

/**
 * Generated class for the TooltipComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "tooltip",
  template:
    '   <div *ngIf="tooltipText" [tooltip]="tooltipText" [positionV]="vPosition" [positionH]="hPosition" [duration]="duration" event="hover" ' +
    '            style="background:white;height:18px;width:18px;border-radius:20px;display:flex;align-items:center;justify-content:center">\n' +
    '     <ion-icon [name]="tooltipIcon" color="#000" style=""></ion-icon>\n' +
    "   </div>",
})
export class TooltipComponent implements OnInit {
  @Input() tooltipText: string;
  @Input() tooltipIcon: string = "information";
  @Input() vPosition: string = "bottom";
  @Input() hPosition: string;
  @Input() duration: number;

  constructor() {
    // console.log('Hello TooltipComponent Component');
  }

  ngOnInit(): void {
    // console.log( "tooltip text", this.tooltipText );
    // console.log( "tooltip icon", this.tooltipIcon );
    this.tooltipIcon = this.tooltipIcon || "information";
    if (!this.duration) {
      this.duration = 3000;
    }
  }
}



// WEBPACK FOOTER //
// ./src/tooltip/tooltip.ts